import React, { useContext } from 'react';
import { AuthContext } from '../App';
import Layout from '../components/Layout';
import { WalletPanel } from '../components/polygon/WalletPanel';
import { usePolygonWallet } from '../components/polygon/usePolygonWallet';
import { SpendingLimits } from '../components/polygon/SpendingLimits';
import { TradeHistorySection } from '../components/history/TradeHistorySection';
import { LiveTradingPermissionToggle } from '../components/dashboard/LiveTradingPermissionToggle';

export default function Dashboard() {
  const { user } = useContext(AuthContext);
  const wallet = usePolygonWallet();
  return (
    <Layout>
      <div className="space-y-8" data-testid="dashboard-container">
        <header>
          <h1 className="text-3xl font-bold text-slate-100 mb-2" data-testid="dashboard-greeting">
            Welcome back, {user?.name?.split(' ')[0]}!
          </h1>
          <p className="text-slate-400 text-sm" data-testid="dashboard-wallet-scope">
            Your wallet, your signatures. Recorded trading activity stays separate.
          </p>
        </header>

        <LiveTradingPermissionToggle key={user?.id} />

        <WalletPanel wallet={wallet} compact />
        <SpendingLimits wallet={wallet} />
        <TradeHistorySection headingLevel="h2" />
      </div>
    </Layout>
  );
}
